import DashboardAccountMappingsMain from "./main";

export function DashboardAccountMappings() {
  return <DashboardAccountMappingsMain />;
}

export default DashboardAccountMappings;
